import { Spin } from "antd";
import { Outlet, useNavigation, useLocation } from "react-router-dom";
import { AppLayout } from "~/components/Layout/AppLayout";

/**
 * Shared shell for /explore (Explore page) and /signup. Keeps AppLayout mounted while child
 * routes swap so navigation never leaves a blank screen during loader runs.
 */
export const PublicShellLayout = () => {
  const navigation = useNavigation();
  const location = useLocation();

  const isChildRouteLoading =
    navigation.state === "loading" &&
    navigation.location != null &&
    navigation.location.pathname !== location.pathname;

  return (
    <AppLayout
      TopNavigation={null}
      SideNavigation={null}
      SideAction={null}
      PageContent={
        isChildRouteLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "50vh",
              width: "100%",
            }}
          >
            <Spin size="large" />
          </div>
        ) : (
          <Outlet />
        )
      }
    />
  );
};
